import React from 'react';
import { Link } from 'react-router';

import './HomeCategories.scss';

import surgeryImgs from '../../../assets/img/llc/surgery/surgeryHomepage';

class HomeCategories extends React.PureComponent {
  renderCategories = () => {
    const surgeries = this.props.langs.surgery;

    return surgeries.map(surgery => (
      <div className="col-4 homeCategories_item_col" key={surgery.id}>
        <Link to={{
          pathname: '/zakroky',
          state: {surgeryId: surgery.id}
        }}>
          <div className="homeCategories_item">
            <img src={surgeryImgs[surgery.imgId]} alt={surgery.id === 2 ? "Laserová a estetická medicína" : surgery.name}/>
            <div className="homeCategories_item_content">
              <i className={`llc-${surgery.icon}`}/>
              <div className="homeCategories_item_title"> {surgery.id === 2 ? "Laserová a estetická medicína" : surgery.name}</div>
              <div className="homeCategories_item_desc">
                {surgery.desc}
              </div>
            </div>
          </div>
        </Link>
      </div>
    ));
  };

  render() {
    return (
      <section className="homeCategories">
        <div className="container" ref={this.props.setRef}>
          <h2 className="text-center line">Zdraví a Krása Na Dosah Ruky</h2>
          <h5 className="text-center">
            Lékaři kliniky LLC plastické chirurgie si poradí s jakýmkoliv <br/> problémem, se kterým se na ně obrátíte.
          </h5>

          <div className="row homeCategories_row">
            {this.renderCategories()}
          </div>
        </div>
      </section>
    );
  }
}

export default HomeCategories;


// WEBPACK FOOTER //
// ./src/components/HomePage/HomeCategories/HomeCategories.js